<div class="my-3 my-md-5">
          <div class="container">
            <div class="page-header">
              <h1 class="page-title">
                Profile
              </h1>
            </div>
              <div class="card">
                    <mat-tab-group [selectedIndex]="selectedIndex">
                        <mat-tab label="Profile" *ngIf="selectedIndex!=1"> 
                            <form [formGroup]="profileForm" (submit)="updateProfile()">
                            <div class="card-body">
                                <div class="container-fluid">
                                    <div class="row">
                                        <div class="col-sm-12 text-center m-4">
                                            <img [src]="profileImg" class="profile-image" />
                                        </div>
                                        <div class="col-md-6 col-lg-6 right-border">
                                            <div class="form-group">
                                                <label class="form-label">Name</label>
                                                <input type="text" formControlName="name" class="form-control" />
                                                <div *ngIf="submitted && f.name.errors" class="invalid-feedback">
                                                    <div *ngIf="f.name.errors.required">Mobile No is required</div>
                                                </div>
                                            </div>
                                            <div class="form-group">
                                                <label class="form-label">Email</label>
                                                <input type="text" formControlName="email" class="form-control" />
                                                <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
                                                    <div *ngIf="f.email.errors.required">Email is required</div>
                                                </div>
                                            </div>
                                            <div class="form-group">
                                                <label class="form-label">Role</label>
                                                <input type="text" readonly="readonly" value="{{role}}" class="form-control" />
                                            </div>
                                        </div>
                                        <div class="col-md-6 col-lg-6">
                                            <div class="form-group">
                                                <label class="form-label">Mobile</label>
                                                <input type="text" formControlName="mobile" class="form-control" />
                                                <div *ngIf="submitted && f.mobile.errors" class="invalid-feedback">
                                                    <div *ngIf="f.mobile.errors.required">Mobile No is required</div>
                                                </div>
                                            </div>
                                            <div class="form-group">
                                                <label class="form-label">Circle</label>
                                                <input type="text" readonly="readonly" value="{{circle}}" class="form-control" />
                                            </div>
                                            <div class="form-group">
                                                <label class="form-label">Image Upload</label>
                                                <input type="file" (change)="selectFile($event)" class="form-control" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="card-footer">
                                <button type="submit" [disabled]="loading" class="btn btn-primary" ><i *ngIf="loading" class="fa fa-spin fa-spinner"></i> Update</button>
                            </div>
                            </form>
                        </mat-tab>
                        <mat-tab label="Change Password"> 
                            <form [formGroup]="passwordForm" (submit)="changePassword()">
                            <div class="card-body">
                                <div class="container-fluid">
                                    <div class="row">
                                        <div class="col-md-6 col-lg-6 right-border">
                                            <div class="form-group">
                                                <label class="form-label">Current Password</label>
                                                <input type="password" formControlName="currentPassword" class="form-control" />
                                                <div *ngIf="psubmitted && p.currentPassword.errors" class="invalid-feedback">
                                                    <div *ngIf="p.currentPassword.errors.required">Current Password is required</div>
                                                </div>
                                            </div>
                                            <div class="form-group">
                                                <label class="form-label">New Password</label>
                                                <input type="password" formControlName="new_password" class="form-control" />
                                                <div *ngIf="psubmitted && p.new_password.errors" class="invalid-feedback">
                                                    <div *ngIf="p.new_password.errors.required">New Password is required</div>
                                                </div>
                                            </div>
                                            <div class="form-group">
                                                <label class="form-label">Confirm Password</label>
                                                <input type="password" formControlName="new_password_confirmation" class="form-control" />
                                                <div *ngIf="psubmitted && p.new_password_confirmation.errors" class="invalid-feedback">
                                                    <div *ngIf="p.new_password_confirmation.errors.required">Confirm Password is required</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="card-footer">
                                <button type="submit" [disabled]="ploading" class="btn btn-primary" ><i *ngIf="ploading" class="fa fa-spin fa-spinner"></i> Update</button>
                            </div>
                            </form>
                        </mat-tab>
                    </mat-tab-group>

              </div>
          </div>
</div>